// extracted by css-extract-rspack-plugin
export default {"form":"KtT_hX4ZC9Q45P9R__form___","select":"SCImM3VwKMMe_rE6__select___"};